import { APP_CONFIG } from '../constants';

export const errorHandler = (error, apiname) => {
    
    let status;
    switch (apiname) {
        case "AUTH":
            status = errorHandlerAuth(error);
            break;

        case "VIRTUAL_CREDENTIAL":
            status = errorHandlerVirtualCredential(error);
            break;

        default:
            break;
    }

    const exception = APP_CONFIG.API[apiname].STATUS_CODE[status];

    return {
        status,
        message: exception ? exception.MESSAGE : 'Error'
    };
};


const errorHandlerAuth = (error) => {

    let status;
    switch (error.description) {
        case APP_CONFIG.API.AUTH.MESSAGES.ERROR.userBlocked:
            status = 401;
            break;

        case APP_CONFIG.API.AUTH.MESSAGES.ERROR.incorrectUserOrPass:
            status = 403;
            break;

        case APP_CONFIG.API.AUTH.MESSAGES.ERROR.userNotVerified:
            status = 412;
            break;

        case APP_CONFIG.API.AUTH.MESSAGES.ERROR.tooManyAttempts:
            status = 429;
            break;

        default:
            break;
    }
    
    return status;
    
};

const errorHandlerVirtualCredential = (error) => {

    const status = error.statusCode || error?.response?.status || error?.status || 500;
    
    return status;

};
